export const ONE_OFF = "ONE_OFF";
export const DAILY = "DAILY";
export const WEEKDAYS = "WEEKDAYS";
export const WEEKLY = "WEEKLY";
export const FOUR_WEEKLY = "FOUR_WEEKLY";
export const LAST_MONTHLY_WEEKDAY = "LAST_MONTHLY_WEEKDAY";
export const MONTHLY = "MONTHLY";
export const QUATERLY = "QUATERLY";
export const ANNUALLY = "ANNUALLY";
